<template>
  <el-table
    class="dt-table"
    :max-height="height"
    :data="data"
    lazy
    row-key="insuredId"
    :load="load"
    :tree-props="{ hasChildren: 'hasChildren' }"
    border
    :highlight-current-row="true"
    :source="source"
    stripe
    v-hover
  >
    <!-- 序号插槽 -->
    <slot name="index"></slot>
    <!-- 单选按钮插槽 -->
    <slot name="radio"></slot>
    <el-table-column
      v-for="item in newOptions"
      :key="item.prop"
      :prop="item.prop"
      :label="item.label"
      :align="align"
      :min-width="item.width"
    >
      <template slot-scope="scope">
        <!-- 当数据有绑定事件时 -->
        <template v-if="item.event">
          <template v-if="item.event === 'getImage'">
            <div class="tableImgWrap">
              <img class="tableImg" v-if="scope.row.imageUrl" :src="scope.row.imageUrl" alt />
              <span class="tableImgLine" v-else>--</span>
            </div>
          </template>
          <template v-else>
            <span class="cursor" @click="handleClick(item.event, scope.row)" :style="{ color: themeObj.color }"
              >{{ scope.row[item.prop] }}{{ item.unit ? item.unit : '' }}</span
            >
          </template>
        </template>
        <!-- 只是普通数据，需要查询字典转换或特定方法过滤 -->
        <template v-else>
          <template v-if="item.dic"
            >{{ scope.row[item.prop] | getDicItemName(item.dic) }}{{ item.unit ? item.unit : '' }}</template
          >
          <template v-else>
            <span class="WelfareFlag" v-if="item.WelfareFlag && scope.row.isWelfare == 1">弹性福利</span>
            {{ getCeil(item.filterType, scope.row[item.prop]) }}{{ item.unit ? item.unit : '' }}</template
          >
        </template>
      </template>
    </el-table-column>
    <!-- 操作按钮插槽 -->
    <slot name="operate"></slot>
  </el-table>
</template>

<script>
import { getDicList } from '@/config/tool';
import { getSubPolicyInsured } from '@/api/insuranceContract';

export default {
  props: {
    data: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    options: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    align: {
      type: String,
      default: 'left',
    },
    height: { type: String, default: 'auto' },
    source: {
      type: String,
      default: '',
    },
  },
  //表头的合同编号
  showPolicyCode: {},
  data() {
    return {
      newOptions: [],
    };
  },
  created() {
    // 给表头赋最小宽度，避免表头换行
    this.newOptions = this.options.map((item) => {
      if (!item.width) {
        if (item.prop === 'name') {
          item.width = Math.max(80, (item.label.length + 1) * 20);
        } else if (/time$/i.test(item.prop)) {
          item.width = 160;
        } else {
          item.width = (item.label.length + 1) * 20;
        }
      }
      return item;
    });
    this.newOptions
      .filter((item) => item.dic)
      .forEach((item) => {
        if (!this.$store.state.dicMap[item.dic]) {
          getDicList(item.dic);
        }
      });
  },
  methods: {
    // 自定义过滤内容方法
    filterType(type, value) {
      return this[type](value);
    },
    // 保留两位小数并添加%
    fixedTwo(value) {
      return Number(value).toFixed(2);
    },
    // 自定义事件，子组件触发，父组件执行
    handleClick(event, row) {
      this.$emit(event, row);
    },
    async load(tree, treeNode, resolve) {
      let param = {
        insuredId: tree.insuredId,
        policyId: tree.policyId,
        source: this.source,
      };
      let res = await getSubPolicyInsured(param);
      if (tree.hasOwnProperty('planPremium')) {
        for (var i = 0; i < res.length; i++) {
          res[i].planPremium = parseInt(res[i].planPremium);
        }
      }
      if (tree.hasOwnProperty('productName')) {
        for (var i = 0; i < res.length; i++) {
          res[i].productName = tree.productName;
          res[i].validityTime = res[i].invalidTime;
        }
      }
      resolve(res);
    },
  },
  computed: {
    getCeil() {
      return function (type, prop) {
        if (type) {
          return this.filterType(type, prop);
        } else {
          // 为了正常显示数字0
          if (prop === undefined || prop === '') return '--';
          return prop;
        }
      };
    },
    themeObj() {
      return this.$store.getters['layoutStore/getThemeObj'];
    },
  },
};
</script>
<style lang="less">
.dt-table {
  .tableImgWrap {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    .tableImg {
      max-width: 100%;
      max-height: 100%;
    }
    .tableImgLine {
      display: block;
      line-height: 80px;
    }
  }
  .cursor {
    cursor: pointer;
  }
}
.el-table .cell .WelfareFlag {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  width: 66px;
  height: 18px;
  line-height: 18px;
  border-radius: 0px 0px 14px 0px;
  font-size: 12px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #ffffff;
  background: linear-gradient(270deg, #e27c00 0%, #f3b300 100%);
}
</style>
